import React from 'react'
import SingleTravel from '../SingleTravel/SingleTravel';
import { Travel } from '../TravelsPlanned/model'
import './AllTravels.min.css'
interface Props {
  travels: Travel[];
  setTravels: React.Dispatch<React.SetStateAction<Travel[]>>;

}

const AllTravels: React.FC<Props> = ({ travels, setTravels }) => {



  return (
    <div className='allTravels'>
      {travels.map((travel) => (
        <SingleTravel travels={travels} setTravels={setTravels}
          travel={travel} key={travel.id} /> /* Trzeba dołożyć key bo inaczej jest warning w React */
        /*travel z małej to jest travel z Props z Single które zawiera city, date itd
        drugie travel w nawiasie to jest przekazanie całego elementu z tablicy travels */
      ))}
    </div>
  )
}

export default AllTravels